import { cn } from '../../lib/utils';
import WorkerPremiumCard, { WorkerPremiumCardHeader } from './WorkerPremiumCard';

const TONE_STYLES = {
  default: { className: '', accent: 'teal' },
  success: { className: 'border-green-200/90 bg-gradient-to-br from-green-50/80 to-white', accent: 'teal' },
  warning: { className: 'border-amber-200/90 bg-gradient-to-br from-amber-50/80 to-white', accent: 'amber' },
  critical: { className: 'border-red-200/90 bg-gradient-to-br from-red-50/80 to-white', accent: 'amber' },
  info: { className: 'border-blue-200/90 bg-gradient-to-br from-blue-50/80 to-white', accent: 'blue' },
  purple: { className: 'border-purple-200/90 bg-gradient-to-br from-purple-50/80 to-white', accent: 'purple' },
};

export function OnboardingPriorityPill({ variant = 'blocking', children, className }) {
  const styles = {
    blocking: 'bg-red-100 text-red-700',
    legal: 'bg-amber-100 text-amber-700',
    training: 'bg-blue-100 text-blue-700',
    care: 'bg-purple-100 text-purple-700',
    complete: 'bg-[#D8E6D5] text-[#1F8F5F]',
  };

  return (
    <span className={cn('rounded-full px-3 py-1 text-xs font-semibold', styles[variant], className)}>
      {children}
    </span>
  );
}

/**
 * Premium card shell for applicant onboarding sections in WorkerDashboard.
 */
export default function OnboardingPremiumCard({
  children,
  tone = 'default',
  accent,
  className,
  padding = 'p-4',
  contentClassName,
  title,
  description,
  icon,
  action,
  header,
  ...props
}) {
  const toneStyle = TONE_STYLES[tone] || TONE_STYLES.default;

  return (
    <WorkerPremiumCard
      accent={accent || toneStyle.accent}
      padding={padding}
      className={cn(toneStyle.className, className)}
      {...props}
    >
      {header || (title ? (
        <WorkerPremiumCardHeader
          icon={icon}
          title={title}
          description={description}
          action={action}
        />
      ) : null)}
      {contentClassName ? <div className={contentClassName}>{children}</div> : children}
    </WorkerPremiumCard>
  );
}